<template>
  <Select :options="packageOptions" :value="action.value" @changeValue="store.commit(`${storeId}.value`, $event)" placeholder=" Package" />
  <Select source="term/search-attribute" :value="action.field" @changeValue="store.commit(`${storeId}.field`, $event)" placeholder="Field" />
</template>

<script>
import DefaultPackage from './DefaultPackage.vue'
export default {
  extends: DefaultPackage
}
</script>
